import { GingerMediaBaseUrl } from "./baseUrls";
import { fetchWrapper } from "./fetchWrapper";

export async function createAdvertisingOptions(
  formValues: any,
  authHeader: string
) {
  const url = `${GingerMediaBaseUrl}/createAdvertisingOptions`
  return fetchWrapper(url, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Authorization: authHeader,
    },
    body: formValues,
  });
}
